import { EditorView, tooltips } from "@codemirror/view"

/**
 * Configure tooltips to mount to document.body instead of the editor container
 * This helps prevent tooltip clipping when the editor is in a container with overflow
 * Sets a high z-index to ensure tooltips appear above dialogs and modals
 */
export const tooltipToBody = [
  tooltips({
    parent: document.body,
  }),
  EditorView.baseTheme({
    ".cm-tooltip": {
      zIndex: "9999 !important",
    },
    ".cm-tooltip-autocomplete": {
      zIndex: "9999 !important",
    },
    ".cm-tooltip-hover": {
      zIndex: "9999 !important",
    },
    ".cm-tooltip-lint": {
      zIndex: "9999 !important",
    },
  }),
]

